import { Routes } from '@angular/router'
import { authGuard } from './guards/auth.guard'
import { adminScopeGuard } from './guards/admin-scope.guard'
import { userSectionGuard } from './guards/user-section.guard'

export const routes: Routes = [
  { path: '', loadComponent: () => import('./home/home.component').then(m => m.HomeComponent), canActivate: [userSectionGuard] },
  { path: 'about', loadComponent: () => import('./about/about.component').then(m => m.AboutComponent), canActivate: [userSectionGuard] },
  { path: 'products', loadComponent: () => import('./products/products.component').then(m => m.ProductsComponent), canActivate: [userSectionGuard] },
  { path: 'explore', loadComponent: () => import('./explore/explore.component').then(m => m.ExploreComponent), canActivate: [userSectionGuard] },
  { path: 'join-insta-linker', loadComponent: () => import('./join-insta-linker/join-insta-linker.component').then(m => m.JoinInstaLinkerComponent), canActivate: [userSectionGuard] },
  { path: 'stores/:username/products/:productId', loadComponent: () => import('./product-detail/product-detail.component').then(m => m.ProductDetailComponent), canActivate: [userSectionGuard] },
  { path: 'stores/:username', loadComponent: () => import('./store-detail/store-detail.component').then(m => m.StoreDetailComponent), canActivate: [userSectionGuard] },
  { path: 'stores', loadComponent: () => import('./stores/stores.component').then(m => m.StoresComponent), canActivate: [userSectionGuard] },
  { path: 'checkout', loadComponent: () => import('./checkout/checkout.component').then(m => m.CheckoutComponent), canActivate: [userSectionGuard] },
  { path: 'store-signup', loadComponent: () => import('./store-signup/store-signup.component').then(m => m.StoreSignupComponent), canActivate: [userSectionGuard] },
  { path: 'login', loadComponent: () => import('./admin-login/admin-login.component').then(m => m.AdminLoginComponent), canActivate: [userSectionGuard] },
  { path: 'admin-login', loadComponent: () => import('./admin-login/admin-login.component').then(m => m.AdminLoginComponent) },
  {
    path: 'super-admin',
    loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent),
    canActivate: [authGuard],
    data: { role: 'super-admin' }
  },
  {
    path: 'super-admin/stores/:username/products/new',
    loadComponent: () => import('./product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    canActivate: [authGuard],
    data: { role: 'super-admin', adminContext: true, createMode: true }
  },
  {
    path: 'super-admin/stores/new',
    loadComponent: () => import('./admin-store-create/admin-store-create.component').then(m => m.AdminStoreCreateComponent),
    canActivate: [authGuard],
    data: { role: 'super-admin' }
  },
  {
    path: 'super-admin/stores/:username/edit',
    loadComponent: () => import('./store-edit/store-edit.component').then(m => m.StoreEditComponent),
    canActivate: [authGuard],
    data: { role: 'super-admin', adminContext: true }
  },
  {
    path: 'super-admin/stores/:username/products/:productId',
    loadComponent: () => import('./product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    canActivate: [authGuard],
    data: { role: 'super-admin', adminContext: true }
  },
  {
    path: 'super-admin/stores/:username',
    loadComponent: () => import('./store-detail/store-detail.component').then(m => m.StoreDetailComponent),
    canActivate: [authGuard],
    data: { role: 'super-admin', adminContext: true }
  },
  {
    path: 'super-admin/:tab',
    loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent),
    canActivate: [authGuard],
    data: { role: 'super-admin' }
  },
  {
    path: 'admin',
    loadComponent: () => import('./admin-store-dashboard/admin-store-dashboard.component').then(m => m.AdminStoreDashboardComponent),
    canActivate: [authGuard, adminScopeGuard],
    data: { role: ['admin', 'seller'] }
  },
  {
    path: 'admin/stores/:username/products/new',
    loadComponent: () => import('./product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    canActivate: [authGuard, adminScopeGuard],
    data: { role: ['admin', 'seller'], adminContext: true, createMode: true }
  },
  {
    path: 'admin/stores/:username/edit',
    loadComponent: () => import('./store-edit/store-edit.component').then(m => m.StoreEditComponent),
    canActivate: [authGuard, adminScopeGuard],
    data: { role: ['admin', 'seller'], adminContext: true }
  },
  {
    path: 'admin/stores/:username/products/:productId',
    loadComponent: () => import('./product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    canActivate: [authGuard, adminScopeGuard],
    data: { role: ['admin', 'seller'], adminContext: true }
  },
  {
    path: 'stores/:username/products/new',
    loadComponent: () => import('./product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    canActivate: [authGuard],
    data: { role: ['seller', 'admin', 'super-admin'], createMode: true }
  },
  {
    path: 'admin/stores/:username',
    loadComponent: () => import('./store-detail/store-detail.component').then(m => m.StoreDetailComponent),
    canActivate: [authGuard, adminScopeGuard],
    data: { role: ['admin', 'seller'], adminContext: true }
  },
  {
    path: 'admin/:tab',
    loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent),
    canActivate: [authGuard, adminScopeGuard],
    data: { role: ['admin', 'seller'] }
  },
  { path: '**', redirectTo: '' }
]
